<template>

    <button class="handle" :styles="styles">
        <i class="fas fa-bars"></i>
    </button>

</template>

<style scoped lang="scss">

    .handle {
        align-items: center;
        cursor: pointer;
        display: flex;
        justify-content: center;
        opacity: 0.5;
        padding: 0 5px;
        &:hover {
            opacity: 1;
        }
        i {
            color: $color-text;
            font-size: 16px;
        }
    }

</style>

<script>

export default {

    props: {
        size: {
            type: Number,
            default: 30,
        },
    },

    computed: {

        styles() {
            return {
                'width': `${this.size}px`,
                'height': `${this.size}px`,
            }
        },

    },

}

</script>